import store from '../store';
import {axios} from '../../handlers/RequestHandler';
import { URL } from '../../config.js';
import Notification from '../../handlers/Notification';
import { notificationOptionSetting } from '../../push-notification';
import { COMPANY_ACCESS } from '../../constants/general'
import moment from 'moment';


//******************************* Utilities
/**
 * Merge the new items from update object to source object, based on the "touched paths" or keys that the update should replace. It has preference for the update over the old data on those keys and leave the rest intact.
 */
const mergeUpdateIntoObject = (paths, source, update) => {
    let result = {...source};

    for(let p in paths){
        result[ paths[p] ] = update[ paths[p] ];
    }

    return result;
}


//*******************************



const clearNotification = () => {
	/* TODO: eliminar esto */
    return (dispatch) => {
        var initNotification = {
                message: '',
                title: '',
                level: 0
        };
        dispatch({
            type: 'NOTIFICATION',
            notification: initNotification
        })
    }
}

const appendNotificationToSidebar = (notification,pag) => {
    let results = {
            type: "ADD_NOTIFICATION_SIDEBAR",
            push: {title: notification.title, msg: notification.msg, url: notification.url, type: notification.type, consumed: notification.consumed, id: notification.id},
            unseenNotifications: notification.consumed === undefined ? true : false
        };
    if(pag){
        results = {title: notification.title, msg: notification.msg, url: notification.url, type: notification.type, consumed: notification.consumed, id: notification.id}
    }
    let list = store.getState();

    /* xHACER: aqui debo validar si debe llevar data el push o no, en vez de preguntar por update preguntar por eso */
    if(notification.update){
        let notification_storeKey = (list[notification.storeKey] && list[notification.storeKey].data) || list[notification.storeKey];
      
        let target = {[notification.storeKey]: null};
        let idx;

		
        if (notification.operation === "replace-from-paginated-list") {
            /* update item in a list. exm: An order in list orders... find by id */
            idx = (list[notification.storeKey] && list[notification.storeKey].data)
                ? list[notification.storeKey].data.findIndex(
                      (elm) => elm.id === notification.update.id
                  )
                : -1;

            let arrayOfPage = list[notification.storeKey].data;
            if (idx !== -1) {
                // found the item in the list
                // debido a la naturaleza asincrona de js, no puedo colocar el siguiente indice en la linea de arriba
                // para hacer un oneliner
                arrayOfPage[idx] = {
                    ...notification.update,
                }; // mergeUpdateIntoObject(notification.touchedPropsToReplace, target[notification.storeKey][idx], notification.update);
                results.updates = { ...notification.update };
            }

            return results;
        }

        if(notification.operation === "replace-from-list"){

            /* update item in a list. exm: An order in list orders... find by id */
       
            idx = notification_storeKey && notification_storeKey.length ? notification_storeKey.findIndex(elm => elm.id === notification.update.id) : -1;
            
            if(idx !== -1){ // found the item in the list

                target[notification.storeKey] = [...list[ notification.storeKey ]];  // retrieve the source data
                target[notification.storeKey][idx] = {...notification.update} // mergeUpdateIntoObject(notification.touchedPropsToReplace, target[notification.storeKey][idx], notification.update);
            }
            else {
                if (notification.type !== "neworder") {
                    target[notification.storeKey] = list[notification.storeKey];
                }
            }
        }

        else if(notification.operation === "append"){
            if (notification.update && notification.storeKey && list[notification.storeKey] ){
                target[notification.storeKey] = [ notification.update, ...list[ notification.storeKey ]];
            }
        }

        else { // here is  notification.update.operation === "replace"

            target[notification.storeKey] = {...list[target.storeKey]};  // retrieve the source data
            target[notification.storeKey] = {...notification.update} // mergeUpdateIntoObject(notification.touchedPropsToReplace, target[notification.storeKey], notification.update);
        }

        results.updates = target;
        if(notification.type === "neworder")
            results.updates.newOrderTableRowAdded = notification.update.id;
    }

    /*if(notification.update){
 probar aqui
    }*/
    //localStorage.setItem("notifications", JSON.stringify([...list.notifications, results.push]) );

    return results;
}

const showNotificationForPushEvent = () => {
    return {
        type: 'PUSH_NOTIFICATION',
        notificationPushEvent: true
    }
}

const setNotificationsListEmpty = () => {
    //localStorage.setItem("notifications", JSON.stringify([]));

    return {
        type: 'EMPTY_NOTIFICATION_LIST'
    }
}


/* Database notifications  */

const fetchNewNotifications = (page = 1) => {

    return (dispatch, getState) => {
        const { session } = getState();
        return axios.get(`${URL}${getState().company.id}/accounts/${getState().session.account_id}/notifications?page=${page}&limit=8`).then( async res => {
            let { data }  = res.data; // aqui la data llega en el objeto res.data.data para hacerlo mas rapido de escribir ya que se repite en varios lados, uso data
            let list = [];
            for( let idx = data.length - 1; idx >= 0; --idx ){
                if(data[idx].type !== "order_provider"){
                    let notification = {
                        title: "",
                        msg: "",
                        url: "",
                        type: `${data[idx].action||''} ${data[idx].type||''}`,
                        update: data[idx].related,//.data,
                        related: data[idx].related,
                        consumed: false,//data[idx].consumed,
                        id: data[idx].id
                    };
                    let res = await notificationOptionSetting(data[idx], data[idx], notification, session);
                    
                    notification = { ...res };
                    notification.title = `${notification.title} - ${getState().company.name}`;
                    list.unshift(notification);
                }
                // console.log("notification =====>",notification);
            }
            dispatch({
                type: "NOTIFICATION_SIDEBAR_LIST",
                notifications: list
            })
             // no esta llegando consumed
            const unseen = data.data//.filter(noti => !noti.consumed);
            dispatch({
                type: "NOTIFICATIONS_UNSEEN",
                unseenNotifications: true//unseen.length ? true : false
            })


        }).catch((err) => {     
            if (err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: err.message
                });
            else
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: getState().json_lang.errors.title_404
                });
        });
    }
}

const fetchNewNotificationsPaginated = (page = 1) => {
    return (dispatch, getState) => {
        const { company, session, userHigherAccess, /* notifications, */ json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})

		let maxNotificationsQty = userHigherAccess === COMPANY_ACCESS ? 10 : 100;
        return axios.get(`${URL + company.id}/accounts/${session.account.id}/notifications?with=related&sort_by=id,desc&page=${page}&limit=${maxNotificationsQty}`).then(async res => {
            const { session } = getState();
			let { data } = res.data;
            var list = []
            for( let idx = data.length - 1; idx >= 0; --idx ){
				const related = data[idx].related;
				let notification = {
					title: "",
					msg: "",
					url: "",
					type: data[idx].action + data[idx].type,
					update: related, //data[idx].data.data,
					consumed: data[idx].consumed,
					id: data[idx].id,
					related
				};

				if (related !== null) { // POR TERMINAR

					data[idx].data = {
						action: data[idx].action,
						type: data[idx].type
					}

					let res = await notificationOptionSetting(data[idx], related, notification,session); //data[idx].data.data, notification);

					notification = await { ...res };
				}
				else {
					notification = {
						...notification,
						title: "Objetivo no encontrado",
						msg: "Este ojeto ha cambiado o fue eliminado y no fue posible acceder a él",
						url: "#"
					}
				}
				if (notification.title){
					notification.title = `${notification.title} - ${company.name}`;
					list.unshift(notification);
				}
			
            }

			res.data.data = list;
			if (userHigherAccess !== COMPANY_ACCESS ){
				res.data.total = list.length;
				res.data.last_page = 1;
			}
            dispatch({
                type: "NOTIFICATIONS_PAGINATED_LIST",
                notificationsPaginated: res.data
			})
        }).catch((err) => {
            if (err.message && err.message !== 'generic')
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: err.message
                });
            else
                Notification.show({
                    type: "error",
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: json_lang.errors.title_404
                });
        });
    }
}

const markNotificationConsumed = (id, isPush) => {
    return (dispatch, getState) => {

        if(isPush){ // si la notificacion viene de un push, en vez de un id tomo el indice del array de la lista de notificaciones que tengo en el store

            const list = getState().notifications;
            let notification = list[id];
            notification.consumed = true;

            dispatch({
                type: "REMOVE_NOTIFICATION_SIDEBAR",
                notifications: list
            });
        }
        else { // si la notificacion viene de la base de datos
            //axios.post(`${URL}${getState().company.id}accounts/${accountId}/notifications/${id}/consume`).then(res => {
            //axios.post(URL + getState().company.id + '/notifications/' + id + '/consume').then(res => {

            axios.post(URL + getState().company.id + '/accounts/' + getState().session.account_id +
            		'/notifications/' + id + '/consume').then(res => {


                // dame la copia, es mas facil traerme la copia y la modifico, asi se modifica directamente en el store sin hacer otra peticion solo para marcarla consumida
                const new_array = getState().notifications;
                const unseenNotifications = new_array.filter(noti => !noti.consumed && noti.id !== id);
                const unseen = unseenNotifications.length ? true : false;
                
                if(new_array.length > 0){
                    let notification = new_array.find(noti => noti.id === id);
                    if(notification){
                         notification.consumed = true;
                    }
                }
               
                const paginated = getState().notificationsPaginated;
                const new_array2 = paginated && paginated.data ? paginated.data : [];
                if(new_array2.length > 0){
                    let notification2 = new_array2.find(noti => noti.id === id);
                    if(notification2){
                        notification2.consumed = true;
                    }
                }
                
                dispatch({
                    type: "REMOVE_NOTIFICATION_SIDEBAR",
                    notifications: new_array,
                    notificationsPaginated: new_array2,
                    unseenNotifications: unseen
                });

            }).catch((err) => {
                if (err.message && err.message !== 'generic')
                    Notification.show({
                        type: "error",
                        title:`Error ${err && err.data && err.data.error_code}`,
                        msg: err.message
                    });
                else
                    Notification.show({
                        type: "error",
                        title:`Error ${err && err.data && err.data.error_code}`,
                        msg: getState().json_lang.custom_errors.retrieving_goods
                    });
            });
        }
    }
}

const sendBroadcastMessage = () => {
    return (dispatch, getState) => {
        let { company, json_lang,sendNotification } = getState();

        let data ={
            title:sendNotification.title,
            body:sendNotification.body,
        }
        if(sendNotification.target_type){
            data.target_type = sendNotification.target_type;
        }
        if(sendNotification.send_at){
            data.send_at = sendNotification.send_at;
            data.send_at_timezone = company.time_zone_offset;
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL+company.id}/send-broadcast-message`,data).then( res => {
            Notification.show({type: "success", title:json_lang.common.success, msg:`Notificación enviada exitosamente` });
            let sendNotification={title:"",body:"",target_type:"",send_at:moment()}
            dispatch({
                type: 'DATA_NOTIFICATION',
                sendNotification: sendNotification
            })
        }).catch((err) => {
            if(err.data && err.data.message)
               Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message[err.data.message] });
            else
                Notification.show({type: "error", title: '', msg: `Error al enviar Notificatión` });
        });
    }   
}

const toggleData = (value) => {
    return (dispatch, getState) => {
        let {sendNotification } = getState();

        sendNotification[value.name] = value.data;
        let data = {...sendNotification}
        dispatch({
            type: 'DATA_NOTIFICATION',
            sendNotification:data
        })
    }
}

const getBroadcastMessage = (page = 1) => {
    return (dispatch, getState) => {
        let { company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL+company.id}/scheduled-tasks?type=notification&page=${page}&sort_by=created_at,desc`).then( res => {
            dispatch({
                type: 'GET_BROADCASTMESSAGE',
                broadcastMessages: res.data
            })
        }).catch((err) => {
            if(err.data && err.data.message)
               Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message[err.data.message] });
            else
                Notification.show({type: "error", title: '', msg: `Error al enviar Notificatión` });
        });
    }
}

const getBroadcastMessageDetail = (id) => {
    return (dispatch, getState) => {
        let { company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL+company.id}/scheduled-tasks/${id}?with_action=1`).then( res => {
            dispatch({
                type: 'GET_BROADCASTMESSAGE_DETAILS',
                broadcastMessageDetails: res.data
            })
        }).catch((err) => {
            if(err.data && err.data.message)
               Notification.show({type: "error", title: 'Error', msg: err.data.message[err.data.message] });
            else
                Notification.show({type: "error", title: '', msg: `Error al enviar Notificatión` });
        });
    }
}

const clearBroadcastMessageDetail = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'GET_BROADCASTMESSAGE_DETAILS',
            broadcastMessageDetails: {}
        })
    }
}

export {
    clearBroadcastMessageDetail,
    getBroadcastMessage,
    toggleData,
    sendBroadcastMessage,
    fetchNewNotificationsPaginated,
    appendNotificationToSidebar,
    fetchNewNotifications,
    markNotificationConsumed,
    clearNotification,
    showNotificationForPushEvent,
    setNotificationsListEmpty,
    mergeUpdateIntoObject,
    getBroadcastMessageDetail
};



// WEBPACK FOOTER //
// ./src/store/actions/notificationsActions.js